import { Helmet } from "react-helmet-async";
import { LibraryListView } from "../../sections/company/library/index.js";
export default function LibraryTP(){
    return (
        <>
            <Helmet>
                <title>Library Management</title>
            </Helmet>
            <LibraryListView />
        </>
    )
}